<template>
  <div class="container test-page">
    <button type="button" class="btn btn-link back-link" @click="$router.back()">
      <i class="las la-arrow-left mr-1"></i>Torna indietro
    </button>

    <div class="test-page-header">
      <div class="test-page-heading">
        <h2 class="test-page-title">Risposte ricevute dal test</h2>
        <div class="test-page-meta" v-if="tests.length > 0">
          <p class="test-page-question">
            <i class="las la-comment-dots mr-1"></i>{{ tests[0].testRequest?.request }}
          </p>
          <span class="test-page-meta-item">
            <i class="las la-calendar mr-1"></i>{{ tests[0].testRequest?.created_at }}
          </span>
          <span class="test-page-meta-item">
            <i class="las la-user mr-1"></i>{{ tests[0].activity_name }}
          </span>
        </div>
      </div>

      <div class="test-page-actions" v-if="tests.length > 0 && tests[0].testRequest?.is_show_responses == false">
        <button type="button" class="btn btn-primary" @click="publishResponses">
          <i class="las la-share mr-1"></i>Pubblica risposte
        </button>
      </div>
    </div>

    <div class="response-loading" v-if="loading">
      <i class="las la-spinner la-spin"></i>
      <p>Caricamento delle risposte in corso...</p>
    </div>

    <div class="response-list" v-else-if="tests.length > 0">
      <div class="response-card" v-for="test in tests" :key="test.id">
        <span class="avatar-initials">{{ initials(test.full_name) }}</span>
        <div class="response-body">
          <div class="response-meta">
            <strong>{{ test.full_name }}</strong>
            <span class="stars" v-if="test.vote != null">
              <i v-for="star in 5" :key="star" class="las la-star"
                :class="star <= test.vote ? 'star-filled' : 'star-empty'"></i>
            </span>
          </div>
          <p class="response-text">{{ test.response }} <span v-if="test.response_note"><br> <em>Note dell'utente:
              </em>{{
                test.response_note }}</span>
          </p>


          <p class="response-note" v-if="test.note">
            <i class="las la-sticky-note mr-1"></i>{{ test.note }}
          </p>

        </div>
        <div class="response-action">
          <button type="button" class="btn btn-sm"
            :class="(test.vote == null || test.note == null) ? 'btn-outline-primary' : 'btn-light'"
            :disabled="test.vote != null && test.note != null" @click="openNote(test)" title="Vota e annota">
            <i class="las la-pen-fancy"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="empty-state" v-else>
      <i class="las la-inbox"></i>
      <p>Nessuna risposta ricevuta per questo test.</p>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="modal-note-form" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Dai un voto e inserisci una nota
            </h5>
            <button type="button" class="close" data-dismiss="modal" id="close-form-note" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit.prevent="saveNote">
            <div class="modal-body p-4">
              <div class="form-group" v-if="formApp.vote == null">
                <label>Voto</label>
                <div class="star-picker">
                  <i v-for="n in 5" :key="n" class="las la-star star-picker-item"
                    :class="n <= formVote.vote ? 'star-filled' : 'star-empty'" @click="formVote.vote = n"></i>
                </div>
              </div>
              <div class="assigned-vote" v-else>
                Voto assegnato: <strong>{{ formApp.vote }}</strong>/5
              </div>

              <div class="form-group mt-3" v-if="formApp.note == null">
                <label for="note">Scrivi qui la tua nota</label>
                <textarea class="form-control" id="note" rows="3" v-model="formVote.note"></textarea>
              </div>
              <div class="assigned-note mt-3" v-else>Note: {{ formVote.note }}</div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Chiudi
              </button>
              <div v-if="formApp.note == null || formApp.vote == null">
                <button type="submit" class="btn btn-primary" :disabled="!formVote.vote">Salva</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
import $ from "jquery";
window.jQuery = $;
window.$ = $;
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
export default {
  name: "TestPage",
  props: ["id"],
  components: {},
  data() {
    return {
      tests: [],
      loading: true,
      formApp: {},
      errors: [],
      formVote: {
        id: 0,
        note: null,
        vote: null,
      },
    };
  },
  mounted() {
    this.loadResponses();
  },
  created() { },
  methods: {
    initials(fullName) {
      if (!fullName) return "?";
      const parts = fullName.trim().split(/\s+/);
      const first = parts[0] ? parts[0][0] : "";
      const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
      return (first + last).toUpperCase();
    },
    async publishResponses() {

      await httpauth.patch('/test/show-result/' + this.id).then(() => {
        const $toast = useToast();
        $toast.open({
          message: 'I risultati sono stati pubblicati',
          type: "info",
          position: "top-right",
          // all of other options may go here
        });
        this.loadResponses();
      }).catch((error) => {
        if (
          error.response.status == 401 &&
          error.response.data.message == "Unauthenticated."
        )
        {
          const auth = useAuth();
          auth.clearToken();
          window.location.href = "/";
        }
      });
    },
    async loadResponses() {
      this.loading = true;
      await httpauth
        .get("/test-responses/show/" + this.id)
        .then((response) => {
          this.tests = response.data.data;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openNote(test) {
      this.formApp = test;
      this.formVote.id = test.id;
      this.formVote.vote = test.vote;
      this.formVote.note = test.note;
      $("#modal-note-form").modal("show");
    },
    saveNote() {
      httpauth
        .post("/test-response/vote-note-response", this.formVote)
        .then((response) => {
          document.getElementById("close-form-note").click();
          const $toast = useToast();

          if (response.data.status)
          {
            this.formVote = {
              id: 0,
              note: null,
              vote: null,
            };
            $toast.open({
              message: response.data.message,
              type: "info",
              position: "top-right",
              // all of other options may go here
            });
          } else
          {
            $toast.open({
              message: response.data.message,
              type: "danger",
              position: "top-right",
              // all of other options may go here
            });
            this.loadResponses();
          }
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          } else if (error.response.data.errors)
          {
            this.errors = error.response.data.errors;
          }
        });
    },
  },
};
</script>
<style scoped>
.test-page {
  padding: 20px;
}

.back-link {
  color: #888;
  padding-left: 0;
  text-decoration: none;
}

.back-link:hover,
.back-link:focus {
  color: #cc9966;
  text-decoration: none;
}

.test-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 0.5rem 0 1.5rem;
}

.test-page-title {
  margin: 0 0 0.5rem;
  font-weight: 600;
  color: #222;
}

.test-page-meta {
  color: #777;
}

.test-page-question {
  margin: 0 0 0.4rem;
  font-weight: 600;
  color: #333;
}

.test-page-meta-item {
  display: inline-flex;
  align-items: center;
  margin-right: 1.2rem;
  color: #999;
}

.test-page-actions {
  flex-shrink: 0;
}

.response-loading,
.empty-state {
  text-align: center;
  color: #999;
  padding: 3rem 1rem;
}

.response-loading i,
.empty-state i {
  font-size: 2.2rem;
  color: #cc9966;
  margin-bottom: 0.75rem;
  display: block;
}

.response-list {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.response-card {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  background-color: #fff;
  border: 1px solid #ebebeb;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 1rem 1.25rem;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.response-card:hover {
  border-color: #e2c39c;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.07);
}

.avatar-initials {
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background-color: #a6c76c;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.response-body {
  flex: 1;
  min-width: 0;
}

.response-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.response-text {
  margin: 0.4rem 0 0;
  color: #333;
}

.response-note {
  margin: 0.5rem 0 0;
  font-style: italic;
  color: #888;
}

.response-action {
  flex-shrink: 0;
}

.stars i {
  margin-right: 1px;
}

.star-filled {
  color: #cc9966;
}

.star-empty {
  color: #e0e0e0;
}

.star-picker {
  display: flex;
  gap: 0.4rem;
}

.star-picker-item {
  font-size: 1.6rem;
  cursor: pointer;
  transition: transform 0.1s ease;
}

.star-picker-item:hover {
  transform: scale(1.15);
}

.assigned-vote,
.assigned-note {
  color: #555;
}

@media (max-width: 575px) {
  .response-card {
    flex-wrap: wrap;
  }

  .response-action {
    width: 100%;
    text-align: right;
  }
}
</style>
